<template>
  <div class="screen" :class="classes" ref="screen">
    <img
      class="screen__img"
      :src="image"
      :width="config.width"
      :height="config.height"
    />
    <div class="screen__content" v-if="screen.content.length">
      <Content
        v-for="content in screen.content"
        :id="`${screen.id}__${content.id}`"
        :baseWidth="baseWidth"
        :baseHeight="baseHeight"
        :content="content"
        :config="config"
        :key="screen.id + content.id"
        :ref="content.id"
        @init="checkConnections"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import Content from "@/components/content";
import arrowCreate from "arrows-svg";

export default {
  components: {
    Content,
  },
  data() {
    return {
      loadedContent: [],
      arrows: [],
      width: 0,
    };
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    screen: {
      type: Object,
      required: true,
    },
  },
  computed: {
    classes() {
      return this.screen.mod ? this.screen.mod.map((c) => `screen--${c}`) : [];
    },
    baseWidth() {
      return this.screen?.width || this.config.width;
    },
    baseHeight() {
      return this.screen?.height || this.config.height;
    },
    image() {
      if (this.screen.image.endsWith("/")) {
        return `${this.config.base}/${this.screen.image}${this.screenWidth}${this.screenPrefix}.jpg`;
      } else {
        return `${this.config.base}/${this.screen.image}`;
      }
    },
    screenPrefix() {
      return window.devicePixelRatio > 1.5 ? "-2x" : "";
    },
    screenWidth() {
      if (this.$vssWidth >= 1200) {
        return "1110";
      }
      if (this.$vssWidth >= 740) {
        return "930";
      }
      return "722";
    },
  },
  watch: {
    screen() {
      this.arrows.forEach((a) => {
        a.clear();
      });
      this.arrows = [];
      this.loadedContent = [];
    },
  },
  methods: {
    checkConnections(id) {
      this.loadedContent.push(id);

      if (this.loadedContent.length === this.screen.content.length) {
        this.screen.content.forEach((c) => {
          if (c.connect && this.$refs[c.connect.element].length) {
            const arrow = arrowCreate({
              from: {
                node: this.$refs[c.id][0].$el,
                direction: c.connect?.from?.direction,
                translation: c.connect?.from?.translation || null,
              },
              to: {
                node: this.$refs[c.connect.element][0].$el,
                direction: c.connect?.to?.direction,
                translation: c.connect?.to?.translation || null,
              },
            });

            this.arrows.push(arrow);
            if (c.connect?.mod) {
              arrow.node
                .querySelector(".arrow")
                .classList.add(c.connect.mod.map((m) => `arrow--${m}`));
            }
            document.body.appendChild(arrow.node);
          }
        });
      }
    },
  },
  beforeDestroy() {
    this.arrows.forEach((a) => {
      a.clear();
    });
  },
};
</script>

<style lang="scss" scoped>
.screen {
  position: relative;
  border-top: 10px solid #ffd100;
  border-bottom: 10px solid #ffd100;

  @include media-breakpoint-down(md) {
    border-top: 5px solid #ffd100;
    border-bottom: 5px solid #ffd100;
  }

  &__img {
    width: 100%;
    height: auto;
  }
  &__content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(#868686, 0.4);
  }
  &--shaded &__content {
    background: none;
  }
}
</style>

<style lang="scss">
.arrow {
  pointer-events: none;
  stroke-linecap: round;
  stroke: #fff;
  fill: transparent;
  stroke-width: 3px;

  @include media-breakpoint-down(md) {
    stroke-width: 2px;
  }

  &--dark {
    stroke: #3373a4;
  }
}
</style>
